import { useEffect, useMemo, useState } from "react";
import { getAlmacen } from "../../../services/backend/catalogService";

const normalize = (value) => String(value || "").trim();

const useSelectedSucursalInfo = ({ cotizacionId, selectedAlmacen, almacenes }) => {
  const [almacen, setAlmacen] = useState("");
  const [sucursal, setSucursal] = useState("");

  const branchFromContext = useMemo(
    () => (Array.isArray(almacenes)
      ? almacenes.find(
          (a) => normalize(a?.almacen) === normalize(selectedAlmacen)
        )?.sucursal || ""
      : ""),
    [almacenes, selectedAlmacen]
  );

  useEffect(() => {
    const id = normalize(cotizacionId);
    const almacenCode = normalize(selectedAlmacen);
    if (!id || !almacenCode) {
      setAlmacen("");
      setSucursal("");
      return;
    }
    let isCurrent = true;
    getAlmacen(id, almacenCode)
      .then((response) => {
        if (!isCurrent) return;
        setAlmacen(normalize(response?.almacen) || almacenCode);
        setSucursal(normalize(response?.sucursal));
      })
      .catch(() => {
        if (!isCurrent) return;
        setAlmacen("");
        setSucursal("");
      })
      .finally(() => {
        if (!isCurrent) return;
      });
    return () => {
      isCurrent = false;
    };
  }, [cotizacionId, selectedAlmacen]);

  return {
    sucursal: sucursal || branchFromContext || selectedAlmacen || "",
    almacen: almacen || selectedAlmacen || "",
  };
};

export default useSelectedSucursalInfo;